// extracted by mini-css-extract-plugin
module.exports = {"table":"BalancesList_table_1PH6V","relative":"BalancesList_relative_UaRhk","modal":"BalancesList_modal_5aVg7"};